import { render } from "./footer.vue?vue&type=template&id=bba63302"
const script = {}

import exportComponent from "/Users/marcusjantorno/Documents/Dados/Trabalho/Marcus Jantorno/SKY/sostec/painel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__